/** @jsxImportSource @emotion/react */
import { Boton } from "@certx/shared";

export default function NotFound() {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: "20px",
      }}
    >
      <h1
        css={{
          color: "var(--azulCertx)",
          fontSize: "1.5em",
          fontWeight: "400",
        }}
      >
        Pagina no encontrada
      </h1>
      <Boton uri="/">Volver al inicio</Boton>
    </div>
  );
}
